import * as React from 'react';
import { Box } from '@mui/material';
import { useGetFlagQuery } from "utils/flagSlice";
import { remCalc } from 'utils/remCalc';
import ClientOnly from 'components/ClientOnly';

const FlagCondition = ({input}) => {
	const { data: flagConditions } = useGetFlagQuery();
	const inlineStyle = {
		'&.FlagCondition-root': {
			display: 'inline-flex',
			gap: remCalc(16),
			alignSelf: 'center',
			alignItems: 'center',
		},
	}

	return (
		<ClientOnly>
			<Box className="FlagCondition-root" sx={inlineStyle}>
				{ flagConditions?.flag && <img src={flagConditions.flag} alt={flagConditions.condition} /> }
				{ flagConditions?.secondaryFlag && <img src={flagConditions.secondaryFlag} alt={flagConditions.secondaryCondition} /> }
			</Box>
		</ClientOnly>
	)
}

export default FlagCondition;